@if (loading || progress) {
  <div class="app-content-status">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
@if (!loading) {
  <div
    class="animate__animated animate__faster animate__fadeIn app-content-wrapper"
  >
    <div #contentContainerHeader class="app-content-header">
      @if (contentContainerTitle) {
        <h1 class="mat-h1">
          <ng-content
            select="app-content-container-title, [contentContainerTitle]"
          ></ng-content>
        </h1>
      }
      <ng-content [select]="[app - content - header]"> </ng-content>
    </div>
    <ng-content></ng-content>
  </div>
}
